<footer class="position-absolute bottom-0 start-50 translate-middle-x">
  <p class="text-center">{{ 'FOOTER_CONTENT' | translate }}</p>
</footer>
